import * as posedetection from "@tensorflow-models/pose-detection";
import {PictogramRenderer} from "./renderer/PictogramRenderer"
import {Canvas2Video} from "canvas2video"
import {FitUtil} from "./FitUtil";
import {Point} from "../Point";

export const CAMERA_MODE = {
  RAW: "RAW",
  FACE_MASK: "FACE_MASK",
  FIGURE: "FIGURE",
}

const col = 10
const row = 20
const speed = 0.0
const rgb = '200,200,200'
const rgbList = rgb.split(',')
const tiles =  new Array(row).fill(null).map(e => {
    return new Array(col).fill(null).map(
      (e2, y) => {
        const a = Math.random() * 0.4 + 0.3 - y * 0.06
        return rgbList.concat([a])
      }
    )
  }
)
export class CameraRenderer {
  constructor() {
    this.currentPos = 0
    this.canvas = document.getElementById('camera-canvas');
    this.ctx = this.canvas.getContext('2d');
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.offsetX = 0;
    this.offsetY = 0;
    this.offsetInitialized = false;
    this.cameraMode = CAMERA_MODE.FIGURE
    this.debugMode = false

    this.pictogramRenderer = new PictogramRenderer()
    this.pictoBgType = "grid"

    this.bgColor = '#fff'

    this.canvas2 = document.getElementById('physics-canvas');
    if (this.canvas2) {
      this.ctx2 = this.canvas2.getContext('2d');
    }

    this.lastResize = 0
  }

  async setup(poseModel) {
    this.poseModel = poseModel
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.ctx.save()
    this.ctx.translate(this.canvas.width, 0);
    this.ctx.scale(-1, 1);
    this.faceImg = new Image()
    this.faceImg.src = 'https://storage.googleapis.com/wcam-27caf.appspot.com/public/face-mark.png'
    await new Promise(resolve => {
      this.faceImg.onload = () => { resolve() }
    })

    window.onresize = () => {
      this.resize()
    }
  }

  resize() {
    if (new Date().getTime() - this.lastResize < 200) {
      return
    }
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.ctx.reset()
    this.ctx.translate(this.canvas.width, 0);
    this.ctx.scale(-1, 1);
    this.setCanvasPos()
    this.lastResize = new Date().getTime()
  }

  clearCtx() {
    this.ctx.clearRect(-this.offsetX, -this.offsetY, this.width, this.height);
    // this.ctx.fillStyle = '#ccc';
    this.ctx.fillStyle = this.bgColor;
    this.ctx.fillRect(-this.offsetX, -this.offsetY, this.width, this.height)
  }

  draw(video, pose, hands) {
    this.clearCtx()
    if (this.cameraMode === CAMERA_MODE.FIGURE) {
      if (this.pictoBgType === 'grid') {
        this.drawFigureBg()
      } else {
        this.drawFigureBg2()
      }
      if (pose && pose[0]) {
        this.drawFigure(pose[0], hands)
      }
    } else {
      this.drawCtx(video)
      if (pose && this.cameraMode === CAMERA_MODE.FACE_MASK) {
        pose.forEach(p => this.drawFaceSticker(p))
      }
    }
    if (this.debugMode) {
      if (pose && pose[0]) {
        this.drawResult(pose[0])
      }
      if (hands) {
        hands.forEach(hand => { this.drawHand(hand) })
      }
    }
  }

  setCanvasPos() {
    this.offsetX = (this.width - video.videoWidth) * 0.5
    this.offsetY = (this.height - video.videoHeight) * 0.5
    this.ctx.translate(this.offsetX, this.offsetY);
    // if (this.ctx2) {
    //   this.ctx2.translate(this.offsetX, this.offsetY);
    // }
  }

  drawCtx(video) {
    this.clearCtx()

    let tmp = this.ctx.globalCompositeOperation
    // this.ctx.globalCompositeOperation = "destination-over";
    this.ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);

    this.ctx.globalCompositeOperation = tmp
    // console.log(this.width, this.height)
    // this.ctx.drawImage(video, 0, 0, this.width, this.height);
  }

  drawResult(pose) {
    if (pose.keypoints != null) {
      this.drawKeyPoints(pose.keypoints, 'Red');
      // this.drawSkeleton(pose.keypoints, pose.id);
    }
  }

  drawFaceSticker(pose) {
    const points = pose.keypoints
    const nose = points[0]

    let size;
    switch (this.poseModel) {
      case posedetection.SupportedModels.BlazePose:
        size = Math.max(
          Point.dist(points[7], nose) * 4,
          Point.dist(points[8], nose) * 4
        )
        break
      case posedetection.SupportedModels.MoveNet:
        size = Math.max(
          Point.dist(points[3], nose) * 3,
          Point.dist(points[4], nose) * 3
        )
        break
    }
    // const w = this.faceImg.width
    // const h = this.faceImg.height
    const w = size
    const h = size
    this.ctx.drawImage(this.faceImg, nose.x - w * 0.5, nose.y - h * 0.5, w, h)
  }

  drawFigure(pose, hands) {
    if (pose.keypoints === null) {
      return
    }

    this.ctx.fillStyle = 'black';
    this.ctx.strokeStyle = 'black';
    this.ctx.lineWidth = 5;

    let keys = pose.keypoints;
    switch (this.poseModel) {
      case posedetection.SupportedModels.BlazePose:
        this.pictogramRenderer.drawBlazePose(this.ctx, keys, hands)
        // this.drawFigureBlazePose(keys, hands)
        break
      case posedetection.SupportedModels.MoveNet:
        this.drawFigureMoveNet(keys)
        hands.forEach(h => this.drawFigureHand(h.keypoints))
        break
    }

  }

  drawLines(points, pairs) {
    pairs.forEach(pair => {
      this.drawLine(points[pair[0]], points[pair[1]])
    })
  }

  drawFigureHand(points) {
    this.drawLines(
      points,
      [
        [0,5], [5,9], [9,13], [13,17], [0,17],
        [5,6],[6,7],[7,8],
        [9,10],[10,11],[11,12],
        [13,14],[14,15],[15,16],
        [17,18],[18,19],[19,20],
        [0,1],[1,2],[2,3],[3,4]
      ]
    )
    this.ctx.beginPath();
    this.ctx.fillStyle = 'White'
    this.ctx.moveTo(points[5].x, points[5].y)
    this.ctx.lineTo(points[9].x, points[9].y)
    this.ctx.lineTo(points[13].x, points[13].y)
    this.ctx.lineTo(points[17].x, points[17].y)
    this.ctx.lineTo(points[0].x, points[0].y)
    this.ctx.lineTo(points[5].x, points[5].y)
    this.ctx.stroke()
    this.ctx.fill()
  }

  drawWall(wall, x, vanishPoint, rgb){
    const grad= this.ctx.createLinearGradient(
      x,
      this.height*0.5,
      vanishPoint.x,
      this.height*0.25-this.offsetY
    )
    grad.addColorStop(0.0 , `rgba(${rgb},1.0)`);
    grad.addColorStop(0.2 , `rgba(${rgb},1.0)`);
    grad.addColorStop(0.6 , `rgba(${rgb},0.7)`);
    grad.addColorStop(0.8 , `rgba(${rgb},0.0)`);
    this.ctx.strokeStyle = grad
    for (let i = 0; i <= wall; i++) {
      this.drawLine(
        {x, y:this.height - i * 3*this.height/wall},
        vanishPoint
      )
    }
  }
  drawCeil(){
    const y = this.height*0.3
    const grad= this.ctx.createLinearGradient(
      0-this.offsetX,
      0-this.offsetY,
      0-this.offsetX,
      y-this.offsetY
    )
    grad.addColorStop(0.0 , `rgba(${rgb},0.5)`);
    grad.addColorStop(0.5 , `rgba(${rgb},0.2)`);
    grad.addColorStop(1.0 , `rgba(${rgb},0.0)`);
    this.ctx.fillStyle = grad
    this.ctx.fillRect(
      -this.offsetX,
      -this.offsetY,
      this.width,
      y
    )
  }

  drawFigureBg2() {
    this.ctx.fillStyle = 'Red'

    const grad= this.ctx.createLinearGradient(
      0-this.offsetX,
      0-this.offsetY,
      0-this.offsetX,
      this.height-this.offsetY
    )
    const rgb2 = '255,0,0'
    grad.addColorStop(0.0 , `rgba(231,74,35,1.0)`);
    grad.addColorStop(0.25 , `rgba(233,103,31,1.0)`);
    grad.addColorStop(0.75 , `rgba(236,132,27,1.0)`);
    grad.addColorStop(1.0 , `rgba(239,161,24,1.0)`);
    this.ctx.fillStyle = grad
    this.ctx.fillRect(
      -this.offsetX,
      -this.offsetY,
      this.width,
      this.height
    )
  }

  drawFigureBg() {
    this.drawCeil()

    if (speed>0.0) {
      this.currentPos+=speed
      if (this.currentPos > row)this.currentPos-=row
    }

    const horizen = this.height*0.1-this.offsetY
    const vanishPoint = {x: this.width*0.5 -this.offsetX, y:horizen}
    const preStroke = this.ctx.strokeStyle
    const preLineWidth = this.ctx.lineWidth
    // this.ctx.strokeStyle = 'white'
    var grad= this.ctx.createLinearGradient(
      this.width*0.5-this.offsetX,
      this.height-this.offsetY,
      this.width*0.5-this.offsetX,
      this.height*0.3-this.offsetY
    )
    grad.addColorStop(0.0 , `rgba(${rgb},1.0)`);
    grad.addColorStop(0.2 , `rgba(${rgb},1.0)`);
    grad.addColorStop(0.6 , `rgba(${rgb},0.7)`);
    grad.addColorStop(0.8 , `rgba(${rgb},0.0)`);
    this.ctx.strokeStyle = grad
    this.ctx.lineWidth = 2


    for (let i = -col; i <= col*2; i++) {
      this.drawLine(
        {x: i*this.width/col -this.offsetX, y:this.height},
        vanishPoint
      )
    }

    // this.drawWall(10, this.width -this.offsetX, vanishPoint, rgb)
    // this.drawWall(10, 0 -this.offsetX, vanishPoint, rgb)

    const getPoint = (x, y) => {
      const seq = row * Math.sqrt((y+ this.currentPos)/row)
      const p1 = { x: x * this.width/col, y: y * this.height / row}
      const h = { x: this.width * 0.5, y: horizen }
      const vec1 = { x: h.x - p1.x, y: h.y - p1.y }
      return {
        x: p1.x + seq*vec1.x/row -this.offsetX,
        y: this.height - seq * (this.height-horizen)/row
      }
    }
    const drawTile = (x, y, color) => {
      const r1 = getPoint(x, y)
      const r2 = getPoint(x, y+1)
      const l1 = getPoint(x+1, y)
      const l2 = getPoint(x+1, y+1)
      this.drawPolygon([r1,r2,l2,l1], color)
    }
    for (let i = -row; i <= row; i++) {
      this.ctx.strokeStyle = grad
      const right = getPoint(-col, i)
      const left = getPoint(col*2, i)
      this.drawLine(right, left)

      const tx = (i + row) % row
      for (let j = -col; j < col; j++) {
        const ty = (j + col) % col
        const rgba = tiles[tx][ty]
        drawTile(i,j, `rgba(${rgba[0]},${rgba[1]},${rgba[2]},${rgba[3] - this.currentPos / row})`)
      }
      // this.ctx.strokeStyle = `rgba(${rgb},${1.0-seq/(row-2)})`
      // // this.drawLine(
      // //   {x: pp1, y:py1},
      // //   {x: pp1, y:-this.offsetY}
      // // )
      // // this.drawLine(
      // //   {x: pp2, y:py1},
      // //   {x: pp2, y:-this.offsetY}
      // // )
    }

    this.ctx.strokeStyle = preStroke
    this.ctx.lineWidth = preLineWidth
    // this.drawPolygon(points, [])
  }

  drawPolygon(points, color) {
    this.ctx.beginPath();
    this.ctx.fillStyle = color
    this.ctx.moveTo(points[0].x, points[0].y)
    for (let i = 1; i < points.length; i++) {
      this.ctx.lineTo(points[i].x, points[i].y)
    }
    this.ctx.lineTo(points[0].x, points[0].y)
    this.ctx.stroke()
    this.ctx.fill()
  }

  drawFigureBlazePose(points, hands) {
    // 体
    this.ctx.beginPath();
    this.ctx.fillStyle = 'White'
    this.ctx.moveTo(points[11].x, points[11].y)
    this.ctx.lineTo(points[12].x, points[12].y)
    this.ctx.lineTo(points[24].x, points[24].y)
    this.ctx.lineTo(points[23].x, points[23].y)
    this.ctx.lineTo(points[11].x, points[11].y)
    this.ctx.stroke()
    this.ctx.fill()

    let sholderR = {
      x: (points[11].x + points[12].x + points[12].x) / 3,
      y: (points[11].y + points[12].y + points[12].y) / 3
    }
    let sholderL = {
      x: (points[11].x + points[11].x + points[12].x) / 3,
      y: (points[11].y + points[11].y + points[12].y) / 3
    }

    // this.drawLine(points[9], sholderL)
    // this.drawLine(points[10], sholderR)
    this.ctx.beginPath();
    this.ctx.fillStyle = 'White'
    this.ctx.moveTo(points[9].x, points[9].y)
    this.ctx.lineTo(points[10].x, points[10].y)
    this.ctx.lineTo(sholderR.x, sholderR.y)
    this.ctx.lineTo(sholderL.x, sholderL.y)
    this.ctx.lineTo(points[9].x, points[9].y)
    this.ctx.stroke()
    this.ctx.fill()

    this.ctx.fillStyle = 'White'
    // this.drawCircle(points[0], 1.5*Math.max(Math.abs(points[0].x-points[7].x), Math.abs(points[0].x-points[8].x)))
    this.drawCircle(points[0], 60)
    this.ctx.fill()

    // hand
    if (!hands || !hands.length) {
      this.drawCircle(points[15], 30)
      this.ctx.fill()
      this.drawCircle(points[16], 30)
      this.ctx.fill()
    }

    // 腕
    this.ctx.lineWidth = 20
    this.drawLines(points, [[11,13],[13,15],[12,14],[14,16]])
    // 足
    this.drawLines(points, [[24,26],[26,28],[28,30],[30,32],[32,28]])
    this.drawLines(points, [[23,25],[25,27],[27,29],[29,31],[31,27]])
    this.ctx.lineWidth = 5
  }

  drawFigureMoveNet(points) {
    this.drawLine(points[5], points[6])
    this.drawLine(points[12], points[6])
    this.drawLine(points[12], points[11])
    this.drawLine(points[5], points[11])

    this.drawLine(points[5], points[7])
    this.drawLine(points[7], points[9])
    this.drawLine(points[6], points[8])
    this.drawLine(points[8], points[10])


    this.drawLine(points[11], points[13])
    this.drawLine(points[12], points[14])
    if (points[15].score > 0.1) {
      this.drawLine(points[13], points[15])
    }
    if (points[16].score > 0.1) {
      this.drawLine(points[14], points[16])
    }
    this.ctx.fillStyle = 'White'
    this.drawCircle(points[0], 120)

    // hand
    this.drawCircle(points[9], 30)
    this.ctx.fill()
    this.drawCircle(points[10], 30)
    this.ctx.fill()
  }

  drawCircle(pos, size) {
    this.ctx.beginPath();
    this.ctx.arc(pos.x, pos.y, size, 0, Math.PI * 2, true);
    this.ctx.stroke();
  }

  drawLine(p1, p2) {
    this.ctx.beginPath();
    this.ctx.moveTo(p1.x, p1.y);
    this.ctx.lineTo(p2.x, p2.y);
    this.ctx.stroke();
  }

  drawHand(hand) {
    if (hand.keypoints != null) {
      this.drawKeyPoints(hand.keypoints, 'Green');
    }

    // this.drawCircle(hand.keypoints[8], 40)
  }

  drawKeyPoints(keypoints, color) {
    this.ctx.fillStyle = color;
    this.ctx.strokeStyle = 'White';
    this.ctx.lineWidth = 2;
    keypoints.forEach(p => this.drawKeypoint(p))
  }

  drawKeypoint(keypoint) {
    // If score is null, just show the keypoint.
    const score = keypoint.score != null ? keypoint.score : 1;
    const scoreThreshold = 0;

    if (score >= scoreThreshold) {
      const circle = new Path2D();
      circle.arc(keypoint.x, keypoint.y, 4, 0, 2 * Math.PI);
      this.ctx.fill(circle);
      this.ctx.stroke(circle);
    }
  }

  // drawSkeleton(keypoints, poseId) {
  //   // Each poseId is mapped to a color in the color palette.
  //   const color = params.STATE.modelConfig.enableTracking && poseId != null ?
  //                 COLOR_PALETTE[poseId % 20] :
  //                 'White';
  //   this.ctx.fillStyle = color;
  //   this.ctx.strokeStyle = color;
  //   this.ctx.lineWidth = params.DEFAULT_LINE_WIDTH;
  //
  //   posedetection.util.getAdjacentPairs(params.STATE.model).forEach(([
  //                                                                      i, j
  //                                                                    ]) => {
  //     const kp1 = keypoints[i];
  //     const kp2 = keypoints[j];
  //
  //     // If score is null, just show the keypoint.
  //     const score1 = kp1.score != null ? kp1.score : 1;
  //     const score2 = kp2.score != null ? kp2.score : 1;
  //     const scoreThreshold = params.STATE.modelConfig.scoreThreshold || 0;
  //
  //     if (score1 >= scoreThreshold && score2 >= scoreThreshold) {
  //       this.ctx.beginPath();
  //       this.ctx.moveTo(kp1.x, kp1.y);
  //       this.ctx.lineTo(kp2.x, kp2.y);
  //       this.ctx.stroke();
  //     }
  //   });
  // }
}



// WEBPACK FOOTER //
// ./src/components/common/CameraRenderer.js